export const links = [
  {
    id: 1,
    text: "home",
    url: "#hero",
  },
  {
    id: 2,
    text: "skills",
    url: "#skills",
  },
  {
    id: 3,
    text: "projects",
    url: "#projects",
  },
  {
    id: 4,
    text: "contacts",
    url: "#contacts",
  },
];
